export default "__VITE_ASSET__BTgfFNP5__"